// PayAmigo API Types

export enum PaymentType {
  Deposit = 'deposit',
  Withdrawal = 'withdrawal',
}

export enum PaymentStatus {
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  PAYMENT_COMPLETED = 'PAYMENT_COMPLETED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  CONVERSION_PENDING = 'CONVERSION_PENDING',
  CONVERSION_COMPLETED = 'CONVERSION_COMPLETED',
  CONVERSION_FAILED = 'CONVERSION_FAILED',
}

export type AvailableCoinsResponse = string[];

export interface QuoteRequest {
  cpf_number: string;
  amount: string;
  coin: string;
  pix_key?: string;
}

export interface QuoteResponse {
  quote_id: string;
  quoted_amount: number;
  price: number;
  quoted_coin: string;
  payment_type: PaymentType;
  expires_at: string;
  underlying_coin: string;
  underlying_amount: number;
  underlying_fee: number;
  quoted_fee?: number;
}

export interface ExecuteRequest {
  quote_id: string;
}

export interface DepositExecuteResponse {
  transaction_id: string;
  status: PaymentStatus.PAYMENT_PENDING;
  created: string;
  pix_data: string | null;
  description: string | null;
  underlying_amount: number | null;
  underlying_coin: string | null;
  quoted_amount: number;
  quoted_coin: string;
  quoted_fee: number;
}

export interface WithdrawalExecuteResponse {
  transaction_id: string;
  status: PaymentStatus.CONVERSION_PENDING;
  quoted_amount: number;
  quoted_coin: string;
  quoted_fee: number;
}

export type ExecuteResponse = DepositExecuteResponse | WithdrawalExecuteResponse;

// WebSocket Types
export interface SubscribeTransactionRequest {
  transactionId: string;
}

export interface SubscriptionConfirmedResponse {
  transactionId: string;
  timestamp: string;
}

export interface StatusUpdateResponse {
  transactionId: string;
  status: PaymentStatus;
  timestamp: string;
  [key: string]: any;
}

